// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-page[data-v-2e8502f4]{border-top:5px solid #a8ddb8;text-align:center;background-color:#fff;padding:5rem}.success-page>*[data-v-2e8502f4]{color:#000}.success-page .alert-text[data-v-2e8502f4]{font-size:1.5rem}.success-page .success-icon[data-v-2e8502f4]{width:100px;height:100px;color:rgba(168,221,184,.8);margin-bottom:3rem}", ""]);
// Exports
module.exports = exports;
